import { useQuery } from "@apollo/client";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import EmptyImage from "../../../../assets/default_img.png";
import LeaderboardsStatusBadge from "../../../../components/leaderboards/leaderboardsStatusBadge/LeaderboardsStatusBadge";
import { getLeaderboardById } from "../../../../graphql/queries/getLeaderboardsList";

export default function LeaderboardOutcomeSummary({ outcome }) {
  const leaderboardData = outcome?.outcomeData;
  const { data } = useQuery(getLeaderboardById, {
    variables: { id: leaderboardData?.leaderboard_id },
    skip: !leaderboardData?.leaderboard_id,
  });
  const leaderboard = data?.getLeaderboard;
  return (
    <Accordion className="leaderboard-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${leaderboardData?.leaderboardData_id}-content`}
        id={`${leaderboard?.leaderboard_id}-header`}
      >
        <div className="display-flex justify-content-space-between align-items-center w-100 mr-2">
          <div className="display-flex">
            <LeaderboardsStatusBadge
              status={"LEADERBOARD"}
              startsAt={leaderboard?.startsAt}
              awardApproval={leaderboard?.awardApproval}
            />
            <Typography
              component="span"
              className="ml-2 leaderboard-title"
              title={leaderboard?.title}
            >
              {leaderboard?.title}
            </Typography>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <p className="font-xs">
            <span className="font-xs font-bold">
              Convert non-winner&apos;s ranking points to program points after
              approval:&nbsp;
            </span>
            <span className="font-xs">{leaderboardData?.conversion_rate}</span>
          </p>
          <table
            className="rewards-list-table mt-2"
            style={{ width: "100%", tableLayout: "fixed" }}
          >
            <thead>
              <tr>
                <th style={{ width: "40%" }}>REWARD NAME</th>
                <th style={{ width: "30%" }}>REWARD ID</th>
                <th style={{ width: "10%" }}>REWARD QUANTITY</th>
                <th style={{ width: "10%" }}>RANK QUANTITY</th>
                <th style={{ width: "10%" }}>RANKING RANGE</th>
              </tr>
            </thead>
            <tbody>
              {leaderboardData?.rewards?.map((reward) => (
                <tr key={reward.id}>
                  <td>
                    <div className="display-flex align-items-center">
                      <img
                        src={reward.image_url || EmptyImage}
                        alt={reward.reward_name}
                        className="reward-image mr-1"
                        width={55}
                        height={55}
                        style={{ objectFit: "cover" }}
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop
                          e.target.src = EmptyImage; // Fallback image
                        }}
                      />
                      <span>{reward.reward_name}</span>
                    </div>
                  </td>
                  <td>{reward.reward_id}</td>
                  <td className="">
                    <div className="display-flex align-items-center">
                      <span>{reward.reward_quantity}</span>
                    </div>
                  </td>
                  <td className="">
                    <div className="display-flex align-items-center">
                      <span>{reward.rank_quantity}</span>
                    </div>
                  </td>
                  <td>
                    {reward.rank_range
                      ? `${reward.rank_range?.from}-${reward.rank_range?.to}`
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
